












































































import { Vue, Component, Mixins, Prop, Watch } from "vue-property-decorator";

import moment from "moment";
import _ from "lodash";

import SelectUsers from "@/components/selectusers.vue";
import SelectStadium from "@/components/selectstadium.vue";
import mAreaPicker from "@/components/mareapicker.vue";

import MyCommon from "@/mixins/common";

@Component({
  components: {
    SelectUsers,
    SelectStadium,
    mAreaPicker,
  },
})
export default class extends Mixins(MyCommon) {
  @Prop() value!: any;

  // 可选的规则项
  @Prop() validRules!: string[];

  @Prop() multiParamsSetting!: any[];

  rules: any[] = this.value || [];

  @Watch("value")
  watchValue(val: any, oldVal: any) {
    if (val) {
      this.rules = val;
    }
  }

  add() {
    this.rules.push({
      name: "",
      value: "",
      group: "",
      valueMap: {},
    });

    this.$emit("change", this.rules);
  }

  remove(idx: number) {
    this.$confirm({
      title: "确认信息",
      content: "确定要删除规则吗？",
      onOk: () => {
        this.rules.splice(idx, 1);

        this.$emit("change", this.rules);
      },
    });
  }

  getGroupItemList(name: string) {
    const found = this.multiParamsSetting.find(el => el.name === name);
    if (found) {
      return found.groupList || [];
    }
    return [];
  }

  setGroupValue(rule:any) {
    rule.value = JSON.stringify(rule.valueMap);
    rule.group = rule.name;
  }

  getMultiParamSetting(name:string) {
    const filteredRules = this.rules.filter(el => el.name !== name);
    const maps:any = {};
    filteredRules.forEach(el => {
      maps[el.name] = true;
    });
    return this.multiParamsSetting.filter(el => !maps[el.name])
  }

  isDictWith(name:string, list:any[]) {
    const found = list.find(el => el.name === name);
    if (found) {
      return Array.isArray(found.dict) && found.dict.length > 0;
    }

    return false;
  }

  isDict(name:string) {
    const found = this.multiParamsSetting.find(el => el.name === name);
    if (found) {
      return Array.isArray(found.dict) && found.dict.length > 0;
    }

    return false;
  }

  isGroup(name:string) {
    const found = this.multiParamsSetting.find(el => el.name === name);
    if (found) {
      return found.isGroup;
    }

    return false;
  }

  getDict(name:string) {
    const found = this.multiParamsSetting.find(el => el.name === name);
    if (found && found.dict && found.dict.length > 0) {
      return found.dict;
    }

    return [];
  }

  // 修改规则项
  changeRuleName(idx: number, val: any) {
    _.set(this.rules, [idx, "name"], val);
    this.$emit("change", this.rules);
  }

  changeRuleValue(idx: number, val: any) {
    console.log("value", val);
    _.set(this.rules, [idx, "value"], val.target.value);
    this.$emit("change", this.rules);
  }

  mounted() {
    this.add();
    // console.log(this.rules)
    // console.log(this.validRules)
  }
}
